import React, { createRef } from "react";
import {
  Alert,
  Box,
  Button,
  capitalize,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  MenuItem,
  Paper,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import Tabs from "@mui/material/Tabs";
import config from "config";
import AiAssistantsTab from "./AiAssistantsTab";
import Tab from "@mui/material/Tab";
import PropTypes from "prop-types";
import PageAbstract from "../../components/PageAbstract";
import _request from "../../actions/_request";
import timezonesAll from "../../timezones";
import dateFormatAll from "../../dateFormat";
import i18n from "../../i18";
import { Link, useNavigate } from "react-router-dom";

import FormatColorFillIcon from "@mui/icons-material/FormatColorFill";
import ReceiptIcon from "@mui/icons-material/Receipt";
import moment from "moment-timezone";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import WaterMark from "../../components/WaterMark";
import AppStoreBillingNotice from "../../components/AppStoreBillingNotice";
import { isAppleBilled } from "../../utils/billing";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}>
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="span" sx={{ color: "var(--text-color)" }}>
            {children}
          </Typography>
        </Box>
      )}
    </Box>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    "id": `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

export default class Profile extends PageAbstract {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      users: [],
      packages: [],
      stripe: [],
      transactions: [],
      metaData: {},
      value: 0,
      timezones: timezonesAll,
      dateFormat: dateFormatAll,
      showPassword: false,
      newPassword: false,
      oldPassword: false,
      oldPass: "",
      newPass: "",
      confirmPass: "",
      invoiceData: "",
      image: null,
      position: "top-left",
      size: "",
      opacity: "",
      selectedFile: null,
      isHovered: false,
      profileImage: null,
      selectedImage: null,
      openDialog: false,
    };

    this.toggleShowPassword = this.toggleShowPassword.bind(this);
    this.toggleNewPassword = this.toggleNewPassword.bind(this);
    this.toggleOldPassword = this.toggleOldPassword.bind(this);
    this.handleSavePassword = this.handleSavePassword.bind(this);
    this.handleOldPassword = this.handleOldPassword.bind(this);
    this.handleNewPass = this.handleNewPass.bind(this);
    this.handleNewPassConfirm = this.handleNewPassConfirm.bind(this);
    this.handleImageChange = this.handleImageChange.bind(this);
    this.handlePositionChange = this.handlePositionChange.bind(this);
    this.handleSizeChange = this.handleSizeChange.bind(this);
    this.handleRemoveImage = this.handleRemoveImage.bind(this);
    this.handleOpacityChange = this.handleOpacityChange.bind(this);
    this.saveWaterMark = this.saveWaterMark.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.fileInput = createRef();
  }

  // Common styles for Select components
  getSelectStyles() {
    return {
      "backgroundColor": "var(--background)",
      "color": "var(--text-color)",
      "borderRadius": "7px",
      "& .MuiOutlinedInput-notchedOutline": {
        "borderColor": "var(--text-color)",
        "borderWidth": "1px"
      },
      "&:hover .MuiOutlinedInput-notchedOutline": {
        "borderColor": "var(--accent-primary)",
        "borderWidth": "2px"
      },
      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
        "borderColor": "var(--accent-primary)",
        "borderWidth": "2px"
      },
      "& .MuiSelect-select": {
        "padding": "12px 14px",
        "color": "var(--text-color)"
      },
      "& .MuiSelect-icon": {
        "color": "var(--text-color)"
      }
    };
  }

  // Common MenuProps for Select components
  getMenuProps() {
    return {
      "PaperProps": {
        "sx": {
          "backgroundColor": "var(--background-menu)",
          "border": "1px solid var(--text-color)",
          "borderRadius": "7px",
          "marginTop": "4px",
          "& .MuiMenuItem-root": {
            "color": "var(--text-color)",
            "backgroundColor": "var(--background-menu)",
            "&:hover": {
              "backgroundColor": "var(--accent-primary)",
              "color": "var(--text-color-reverse)"
            },
            "&.Mui-selected": {
              "backgroundColor": "var(--accent-primary)",
              "color": "var(--text-color-reverse)",
              "&:hover": {
                "backgroundColor": "var(--accent-primary)",
                "opacity": 0.8
              }
            }
          }
        }
      }
    };
  }

  // Common styles for TextField components
  getTextFieldStyles() {
    return {
      "& .MuiOutlinedInput-root": {
        "backgroundColor": "var(--background)",
        "color": "var(--text-color)",
        "borderRadius": "7px",
        "& fieldset": {
          "borderColor": "var(--text-color)",
          "borderWidth": "1px"
        },
        "&:hover fieldset": {
          "borderColor": "var(--accent-primary)",
          "borderWidth": "2px"
        },
        "&.Mui-focused fieldset": {
          "borderColor": "var(--accent-primary)",
          "borderWidth": "2px"
        },
        "& input": {
          "color": "var(--text-color)",
          "padding": "12px 14px"
        }
      }
    };
  }
  async loadData() {
    const accResp = await _request.users.getAll();
    this.state.users = accResp?.data?.items || [];

    const pkgResp = await _request.packages.getAll();
    this.state.packages = pkgResp?.data?.items || [];

    const stripeResp = await _request.transactions.getAll();
    this.state.transactions = stripeResp?.data?.items || [];

    const res = await _request.users.getMeta();
    const metaData = res?.data.user || {};

    this.setState({ metaData });
  }

  async componentDidMount() {
    try {
      await this.loadData();
      const { users } = this.state;
      if (users.length > 0 && users[0]?.stripe_customer_id) {
        const invoiceData = await _request.stripe.invoice(
          users[0].stripe_customer_id
        );
        this.setState({ invoiceData });
      }
    } catch (error) {
      console.error("Error mounting component:", error);
    }
  }

  handleChange = (event, newValue) => {
    this.setState({ value: newValue });
  };

  renderTimezoneOptions() {
    const { timezones } = this.state;

    return timezones.map((timezone) => (
      <MenuItem key={timezone.id} value={timezone.id}>
        {timezone.name}
      </MenuItem>
    ));
  }

  renderDateFormatOptions() {
    const { dateFormat } = this.state;

    return dateFormat.map((format) => (
      <MenuItem key={format.id} value={format.date}>
        {format.name}
      </MenuItem>
    ));
  }

  handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      this.setState({
        selectedImage: file,
        profileImage: URL.createObjectURL(file),
      });
      this.uploadImage(file);
    }
  };

  uploadImage = async (file) => {
    const obj = { file };

    await _request.accounts.loading(async () => {
      return await _request.accounts.uploadImage(obj);
    }, this.onPostSend.bind(this));

    this.refresh();
  };

  deleteImage = async () => {
    this.setState({ profileImage: null });
    const obj = {
      image: null,
    };

    await _request.accounts.loading(async () => {
      return await _request.accounts.removeImage(obj);
    }, this.onPostSend.bind(this));

    this.refresh();
  };

  triggerFileInput = () => {
    this.fileInput.current.click();
  };
  accountContent() {
    const { users, profileImage } = this.state;
    const userImage = users[0]?.id;
    const imageSrc =
      profileImage ||
      (userImage
        ? _request.accounts.formLink(userImage, 300)
        :
          "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 300 300'%3E%3Crect width='300' height='300' fill='%23e0e0e0'/%3E%3C/svg%3E");

    return (
      <Box className="flex flex-col lg:flex-row justify-start gap-4 lg:gap-12 xl:gap-48">
        <Box className="w-full lg:w-auto lg:mr-4">
          <Box className="flex column items-center gap-4 lg:gap-8">
            <Box
              className={
                "flex centerV centerH w-[120px] h-[120px] sm:w-[140px] sm:h-[140px] " +
                "md:w-[160px] md:h-[160px] lg:w-[179px] lg:h-[179px] rounded-full " +
                "border-2 border-gray-200 overflow-hidden cursor-pointer"
              }>
              <img
                src={imageSrc}
                alt=""
                className="w-full h-full object-cover"
              />
            </Box>
            <Box className="flex flex-col sm:flex-row center gap-2">
              <Box
                className="btnDark responsive-button"
                onClick={this.triggerFileInput}>
                {i18n.t("profilePage.uploadNewPhoto")}
              </Box>
              {userImage && (
                <Box
                  className="btnDark responsive-button"
                  onClick={this.deleteImage}>
                  {i18n.t("profilePage.remove")}
                </Box>
              )}
            </Box>
            <input
              type="file"
              ref={this.fileInput}
              style={{ display: "none" }}
              onChange={this.handleFileChange}
              alt=""
            />
          </Box>
        </Box>
        <Box className="w-full max-w-md lg:max-w-lg xl:max-w-xl">
          {users.map((user) => (
            <Box key={user.id} className="mb-4 lg:mb-6 profile-form-section">
              <Box className="flex column gap4">
                <Typography
                  component="span"
                  className="text-responsive-base"
                  sx={{ color: "var(--text-color)" }}>
                  {i18n.t("profilePage.fullName")}
                </Typography>
                {this.insertGlobalInput({
                  inputRef: (el) => (this.fullName = el),
                  defaultValue: user.full_name,
                  placeholder: i18n.t("profilePage.fullName"),
                  size: "large",
                  onChange: this.handleNameChange,
                  InputProps: {
                    sx: {
                      color: "var(--text-color)",
                      backgroundColor: "var(--background)",
                      border: "1px solid var(--text-color)",
                      borderRadius: "7px",
                    },
                  },
                })}
              </Box>
              <Box className="flex column gap4 mt-4 mb-2">
                <Typography
                  component="span"
                  sx={{ color: "var(--text-color)" }}>
                  {i18n.t("profilePage.companyName")}
                </Typography>
                {this.insertGlobalInput({
                  inputRef: (el) => (this.companyName = el),
                  defaultValue: user.company_name,
                  placeholder: i18n.t("profilePage.companyName"),
                  size: "large",
                  onChange: this.handleCompanyNameChange,
                  InputProps: {
                    sx: {
                      color: "var(--text-color)",
                      backgroundColor: "var(--background)",
                      border: "1px solid var(--text-color)",
                      borderRadius: "7px",
                    },
                  },
                })}
              </Box>
              <Box className="flex column gap4 mt-4 mb-2">
                <Typography
                  component="span"
                  sx={{ color: "var(--text-color)" }}>
                  {i18n.t("profilePage.email")}
                </Typography>
                {this.insertGlobalInput({
                  inputRef: (ref) => (this.emailRef = ref),
                  size: "large",
                  value: user.email,
                  placeholder: i18n.t("profilePage.email"),
                  disabled: true,
                  InputProps: {
                    sx: {
                      "& .Mui-disabled": {
                        color: "var(--color-input) !important",
                        backgroundColor: "var(--background) !important",
                        border: `1px solid rgba(255, 255, 255, 0.35) !important`,
                        opacity: "unset !important",
                        WebkitTextFillColor: "unset !important",
                        WebkitBoxShadow: "none !important",
                        boxShadow: "none !important",
                        borderRadius: "7px !important",
                      },
                    },
                  },
                })}
              </Box>
              <FormControl fullWidth margin="normal">
                <Typography
                  id="timezone-label"
                  component="label"
                  sx={{ 
                    color: "var(--text-color)",
                    marginBottom: "8px",
                    display: "block",
                    fontSize: "14px",
                    fontWeight: 500
                  }}>
                  {i18n.t("profilePage.timezone")}
                </Typography>
                <Select
                  sx={this.getSelectStyles()}
                  MenuProps={this.getMenuProps()}
                  labelId="timezone-label"
                  id="timezone-select"
                  defaultValue={user.timezone || ""}
                  onChange={this.handleTimezoneChange}
                  variant="outlined">
                  {this.renderTimezoneOptions()}
                </Select>
              </FormControl>

              <FormControl fullWidth margin="normal">
                <Typography
                  id="date-format-label"
                  component="label"
                  sx={{ 
                    color: "var(--text-color)",
                    marginBottom: "8px",
                    display: "block",
                    fontSize: "14px",
                    fontWeight: 500
                  }}>
                  {i18n.t("profilePage.dateFormat")}
                </Typography>
                <Select
                  sx={this.getSelectStyles()}
                  MenuProps={this.getMenuProps()}
                  labelId="date-format-label"
                  variant="outlined"
                  id="date-format-select"
                  defaultValue={user.date_format || ""}
                  onChange={this.handleDateFormatChange}>
                  {this.renderDateFormatOptions()}
                </Select>
              </FormControl>
            </Box>
          ))}
          <Box className="w-max mt-4">
            <Box
              className="btnDark"
              onClick={this.handleSaveProfile.bind(this, users[0]?.id)}>
              {i18n.t("profilePage.save")}
            </Box>
          </Box>
          <Box className="w-max mt-4">
            <Box className="flex column">
              <Typography
                sx={{ fontSize: "16px", color: "var(--text-color)" }}
                component="span">
                {i18n.t("profilePage.cancel")}
              </Typography>
              <Typography
                sx={{ fontSize: "14px", color: "gray" }}
                component="span">
                {i18n.t("profilePage.cancelDetails")}
              </Typography>
            </Box>
            <Box className="mt-4">
              <Button
                variant="outlined"
                color="error"
                className="button d-inline-block mt-4 ml-0 mr-0 confirm"
                onClick={this.handleCancelAccount}>
                {i18n.t("profilePage.cancel")}
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    );
  }

  handleNameChange = (event) => {
    const newTitle = event.target.value;
    this.setState({ fullName: newTitle });
  };

  handleCompanyNameChange = (event) => {
    const newTitle = event.target.value;
    this.setState({ company_name: newTitle });
  };

  handleTimezoneChange = (event) => {
    const newTimezone = event.target.value;
    this.setState({ timezone: newTimezone });
  };

  handleDateFormatChange = (event) => {
    const newDateFormat = event.target.value;
    this.setState({ date_format: newDateFormat });
  };

  handleSaveProfile = (id) => {
    const email = this.emailRef.value;
    const fullName = this.fullName.value;
    const companyName = this.companyName.value;
    const timezone = this.state.timezone;
    const dateFormat = this.state.date_format;

    const user = {
      email,
      full_name: fullName,
      company_name: companyName,
      timezone,
      date_format: dateFormat,
    };

    if (id) user.id = id;

    _request.users.loading(async () => {
      const resp = await _request.users.addUpdate(user);
      if (resp?.isOk && globalThis.app) {
        globalThis.app.loadMetaData(null, true);
      }
      return resp;
    });
  };

  onPostSend(resp) {
  }

  handleCancelAccount = () => {
  };

  async handleSavePassword(id) {
    const oldPassword = this.oldPass.value;
    const newPassword = this.newPass.value;
    const confirmPassword = this.confirmPass.value;

    if (newPassword !== confirmPassword) {
      this.setState({ resetError: i18n.t("profilePage.passwordsDontMatch") });
      return;
    }

    if (newPassword.length < 8) {
      this.setState({ resetError: i18n.t("profilePage.passwordTooShort") });
      return;
    }

    const user = {
      old_password: oldPassword,
      new_password: newPassword,
    };

    if (id) {
      user.id = id;
    }

    const resp = await _request.auth.loading(async () => {
      return await _request.users.updatePassword(user);
    });

    if (resp?.isOk === true) {
      this.setState({
        resetError: null,
        successMessage: i18n.t("profilePage.passwordUpdatedSuccessfully"),
      });
    } else {
      this.setState({
        resetError:
          resp?.message || i18n.t("profilePage.errorResettingPassword"),
      });
    }
  }

  passwordContent() {
    const {
      showPassword,
      newPassword,
      oldPassword,
      users,
      resetError,
      successMessage,
    } = this.state;

    return (
      <Box className="max-w-md">
        {resetError && (
          <Alert severity="error" sx={{ mb: 2 }}>
            {resetError}
          </Alert>
        )}
        {successMessage && (
          <Alert severity="success" sx={{ mb: 2 }}>
            {successMessage}
          </Alert>
        )}

        <Box className="flex column gap4 relative">
          <Typography component="span">
            {i18n.t("profilePage.nowPassword")}
          </Typography>
          {this.insertGlobalInput({
            inputRef: (el) => (this.oldPass = el),
            type: showPassword ? "text" : "password",
            placeholder: i18n.t("profilePage.nowPassword"),
            size: "large",
            onChange: this.handleOldPassword,
            InputProps: {
              sx: {
                color: "var(--text-color)",
                backgroundColor: "var(--background)",
                border: "1px solid var(--text-color)",
                borderRadius: "7px",
              },
            },
          })}
          <Box
            className="cursor-pointer absolute right-2 top-11"
            onClick={this.toggleShowPassword}>
            {showPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
          </Box>
        </Box>

        <Box className="flex column gap4 mt-4 mb-2 relative">
          <Typography component="span">
            {i18n.t("profilePage.newPassword")}
          </Typography>
          {this.insertGlobalInput({
            inputRef: (el) => (this.newPass = el),
            type: newPassword ? "text" : "password",
            placeholder: i18n.t("profilePage.newPassword"),
            size: "large",
            onChange: this.handleNewPass,
            InputProps: {
              sx: {
                color: "var(--text-color)",
                backgroundColor: "var(--background)",
                border: "1px solid var(--text-color)",
                borderRadius: "7px",
              },
            },
          })}
          <Box
            className="cursor-pointer absolute right-2 top-11"
            onClick={this.toggleNewPassword}>
            {newPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
          </Box>
        </Box>

        <Box className="flex column gap4 mt-4 mb-2 relative">
          <Typography component="span">
            {i18n.t("profilePage.confirmPass")}
          </Typography>
          {this.insertGlobalInput({
            inputRef: (el) => (this.confirmPass = el),
            type: oldPassword ? "text" : "password",
            placeholder: i18n.t("profilePage.confirmPass"),
            size: "large",
            onChange: this.handleNewPassConfirm,
            InputProps: {
              sx: {
                color: "var(--text-color)",
                backgroundColor: "var(--background)",
                border: "1px solid var(--text-color)",
                borderRadius: "7px",
              },
            },
          })}
          <Box
            className="cursor-pointer absolute right-2 top-11"
            onClick={this.toggleOldPassword}>
            {oldPassword ? <VisibilityOffIcon /> : <RemoveRedEyeIcon />}
          </Box>
        </Box>

        <Box className="flex gap4 mt-4 mb-2">
          <Box
            className="btnDark"
            onClick={this.handleSavePassword.bind(this, users[0]?.id)}>
            {i18n.t("profilePage.changePass")}
          </Box>
        </Box>
      </Box>
    );
  }

  handleOldPassword(event) {
    const oldPass = event.target.value;
    this.setState({ oldPass: oldPass });
  }

  handleNewPass() {
    const newPass = this.newPass.value;
    this.setState({ newPass: newPass });
  }

  handleNewPassConfirm() {
    const confirmPass = this.confirmPass.value;
    this.setState({ confirmPass: confirmPass });
  }

  toggleShowPassword() {
    this.setState({ showPassword: !this.state.showPassword });
  }

  toggleNewPassword() {
    this.setState({ newPassword: !this.state.newPassword });
  }

  toggleOldPassword() {
    this.setState({ oldPassword: !this.state.oldPassword });
  }

  handleCloseDialog = () => {
    this.setState({ openDialog: false });
  };

  handleResumeSubscription = () => {
    const navigate = useNavigate();

    navigate("/app/pricing");
  };

  handleCancelSubscription = () => {
    const { transactions, users } = this.state;

    if (!transactions.length || !users.length) {
      console.error("No transactions or users found.");
      return;
    }

    const subscription = transactions.find(
      (transaction) =>
        transaction.expire_date &&
        new Date(transaction.expire_date).getTime() > Date.now()
    );

    if (!subscription) {
      console.error("Subscription not found or invalid data.");
      return;
    }

    const obj = {
      subscription_id: subscription.subscription_id,
      cancel_immediately: false,
    };

    _request.stripe.loading(async () => {
      try {
        const response = await _request.stripe.cancelSubscription(obj);
        if (response.isOk === true) {
          const cancellationDate = new Date(subscription.expire_date);
          const formattedDate = cancellationDate.toLocaleDateString();

          this.setState({
            openDialog: false,
            isCanceled: true,
            cancellationDate: formattedDate,
          });
        }
      } catch (error) {
        console.error("Error canceling subscription:", error);
      }
    }, this.onPostSend.bind(this));
  };

  handleOpenDialog = () => {
    this.setState({ openDialog: true });
  };

  handleCancelEndOfPeriod = () => {
    this.handleCancelSubscription();
  };

  subscriptionContent(userInfo) {
    const { users, packages, invoiceData } = this.state;
    const packageIndex = packages.findIndex(
      (pkg) => pkg.id === userInfo?.package
    );
    const packageInfo = packageIndex !== -1 ? packages[packageIndex] : null;
    let formattedDate;

    if (userInfo?.package === 8) {
      formattedDate = i18n.t("profilePage.expired");
    } else if (userInfo?.package === 9) {
      formattedDate = i18n.t("profilePage.pausedCanceled");
    } else {
      const expirationDate = moment(userInfo?.expire_date);

      // Trial / not-yet-billed accounts can have an empty expire_date; moment()
      // would render the literal "Invalid date" — show a neutral dash instead.
      if (!userInfo?.expire_date || !expirationDate.isValid()) {
        formattedDate = "—";
      } else {
        formattedDate = expirationDate.format(userInfo?.date_format);
      }
    }

    return (
      <>
        <Paper
          elevation={2}
          className="p-4"
          sx={{ backgroundColor: "var(--background-menu)" }}>
          {users.map((user) => (
            <Box key={user.id}>
              <Box className="flex justify-between">
                <Box>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ color: "var(--text-color)" }}>
                    {i18n.t("profilePage.currentPackage")}:{" "}
                    <Typography
                      variant="body1"
                      component="span"
                      sx={{ color: "#42C0C7" }}>
                      {packageInfo
                        ? packageInfo.title
                        : i18n.t("profilePage.notAvailable")}
                    </Typography>
                  </Typography>
                  <Typography
                    variant="h6"
                    component="h6"
                    sx={{ color: "var(--text-color)" }}>
                    {i18n.t("profilePage.expireDate")}:{" "}
                    <Typography
                      variant="body1"
                      component="span"
                      sx={{ color: "#42C0C7" }}>
                      {formattedDate}
                    </Typography>
                  </Typography>
                  {isAppleBilled(userInfo) ? (
                    <AppStoreBillingNotice sx={{ mt: 2, mb: 0 }} />
                  ) : (
                    <Box
                      className="flex gap8 mt-4"
                      sx={{
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}>
                      <Box className="flex gap8" sx={{ alignItems: "center" }}>
                        <Link
                          to="/app/pricing"
                          className="flex items-center btnDark"
                          style={{ height: "49px" }}>
                          {i18n.t("profilePage.changeSubscriptionPlan")}
                        </Link>
                        <Typography
                          style={{
                            background: "#fff",
                            border: "solid 1px #D2D8DB",
                            padding: "10px",
                            fontSize: "18px",
                            borderRadius: "5px",
                          }}>
                          {packageInfo && packageInfo.id === 9 ? (
                            <>{i18n.t("profilePage.subscriptionCanceled")}</>
                          ) : (
                            <>
                              {i18n.t("profilePage.willBeBilled")}{" "}
                              <Typography
                                variant="body1"
                                component="span"
                                style={{ fontWeight: "bold" }}
                                color="primary">
                                {packageInfo
                                  ? `$${
                                      packageInfo.price_monthly
                                        ? packageInfo.price_monthly
                                        : "9"
                                    }`
                                  : i18n.t("profilePage.notAvailable")}
                              </Typography>{" "}
                              {i18n.t("profilePage.on")} {formattedDate}
                            </>
                          )}
                        </Typography>
                      </Box>
                      <Box>
                        {" "}
                        {packageInfo && packageInfo.id === 9 ? (
                          <Button
                            variant="contained"
                            color="warning"
                            sx={{ height: "49px", minWidth: "150px" }}
                            onClick={this.handleResumeSubscription}>
                            {i18n.t("profilePage.renewSubscription")}
                          </Button>
                        ) : !this.state.isCanceled ? (
                          <Button
                            variant="outlined"
                            color="error"
                            sx={{ height: "49px", minWidth: "150px" }}
                            onClick={this.handleOpenDialog}>
                            {i18n.t("profilePage.cancelSubscription")}
                          </Button>
                        ) : (
                          <Button
                            variant="outlined"
                            color="error"
                            sx={{ height: "49px", minWidth: "150px" }}
                            disabled>
                            {i18n.t("profilePage.subscriptionEnds")}{" "}
                            {this.state.cancellationDate}
                          </Button>
                        )}
                        <Dialog
                          sx={{
                            "& .MuiDialog-paper": {
                              backgroundColor: "var(--background-menu)",
                            },
                          }}
                          open={this.state.openDialog}
                          onClose={this.handleCloseDialog}>
                          <DialogTitle sx={{ color: "var(--text-color)" }}>
                            {i18n.t("profilePage.confirmCancellation")}
                          </DialogTitle>
                          <DialogContent sx={{ color: "var(--text-color)" }}>
                            <p>{i18n.t("profilePage.cancelConfirmText")}</p>
                            <p>{i18n.t("profilePage.cancelEffectText")}</p>
                          </DialogContent>
                          <DialogActions>
                            <Box
                              className="custom-button"
                              onClick={this.handleCancelEndOfPeriod}>
                              {i18n.t("profilePage.cancelEndOfPeriod")}
                              <Box
                                className="date"
                                style={{ fontSize: "12px", marginTop: "4px" }}>
                                {formattedDate}
                              </Box>
                            </Box>
                            <Box
                              className="custom-button"
                              onClick={this.handleCloseDialog}>
                              {i18n.t("profilePage.close")}
                            </Box>
                          </DialogActions>
                        </Dialog>
                      </Box>
                    </Box>
                  )}
                </Box>
              </Box>
            </Box>
          ))}
        </Paper>
        <Box className="mt-8">
          <Box className="mt-4 mb-4 border-0 border-t border-solid border-gray-300" />
          <Typography variant="h5" component="h5">
            {i18n.t("profilePage.paymentsHistory")}
          </Typography>
          <Box className="mt-4 mb-4 border-0 border-t border-solid border-gray-300" />
          <Box>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.saleId")}
                  </TableCell>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.amount")}
                  </TableCell>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.type")}
                  </TableCell>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.created")}
                  </TableCell>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.expires")}
                  </TableCell>
                  <TableCell
                    style={{ width: "20%", color: "var(--text-color)" }}>
                    {i18n.t("profilePage.status")}
                  </TableCell>
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {invoiceData && invoiceData.data ? (
                  invoiceData.data.map((invoice) => {
                    const momentDate = moment.unix(invoice.period_start);
                    const dateFormat = momentDate.format(userInfo?.date_format);
                    const currencySymbol = this.getCurrencySymbol(
                      invoice.currency
                    );
                    const totalAmount = invoice.total;
                    const formattedTotal = (totalAmount / 100).toFixed(2);

                    const periodStart = new Date(invoice.period_start * 1000);
                    const periodEnd = new Date(invoice.period_end * 1000);
                    const trialType =
                      periodEnd.getTime() - periodStart.getTime() <=
                      7 * 24 * 60 * 60 * 1000
                        ? "7-days"
                        : "full-month";
                    const uppercaseStatus =
                      trialType === "7-days"
                        ? i18n.t("profilePage.trial")
                        : invoice.status.toUpperCase();
                    const expirationDate = new Date(invoice.period_end * 1000);

                    const formattedExpirationDate =
                      expirationDate.toLocaleDateString("en-US", {
                        year: "numeric",
                        month: "short",
                        day: "numeric",
                      });

                    return (
                      <TableRow
                        sx={{ backgroundColor: "var(--background-menu)" }}
                        key={invoice.id}>
                        <TableCell sx={{ color: "var(--text-color)" }}>
                          {invoice.number}
                        </TableCell>
                        <TableCell sx={{ color: "var(--text-color)" }}>
                          {currencySymbol}
                          {formattedTotal}
                        </TableCell>
                        <TableCell sx={{ color: "var(--text-color)" }}>
                          {capitalize(invoice.lines.data[0].type)}
                        </TableCell>
                        <TableCell sx={{ color: "var(--text-color)" }}>
                          {dateFormat}
                        </TableCell>
                        <TableCell sx={{ color: "var(--text-color)" }}>
                          {formattedExpirationDate}
                        </TableCell>
                        <TableCell>
                          <span
                            style={{
                              display: "inline-block",
                              maxWidth: "fit-content",
                              backgroundColor: "#84d784",
                              padding: "2px 9px",
                              borderRadius: "5px",
                              color: "#36855a",
                              fontWeight: "bold",
                              textTransform: "capitalize",
                            }}>
                            {uppercaseStatus}
                          </span>
                        </TableCell>
                        <TableCell>
                          <Tooltip
                            title={`${i18n.t("profilePage.viewInvoice")} ${
                              invoice.number
                            }`}>
                            <a
                              className="btnDark"
                              href={invoice.hosted_invoice_url}
                              target="_blank"
                              rel="noopener noreferrer">
                              <ReceiptIcon />
                            </a>
                          </Tooltip>
                        </TableCell>
                      </TableRow>
                    );
                  })
                ) : (
                  <TableRow>
                    <TableCell
                      colSpan={6}
                      sx={{
                        textAlign: "center",
                        backgroundColor: "var(--background-menu)",
                      }}>
                      <FormatColorFillIcon
                        sx={{
                          fontSize: 80,
                          color: "#1376a8",
                          marginBottom: 2,
                        }}
                      />
                      <Typography
                        component="span"
                        variant="h5"
                        className="text-gray-400 text-lg block mb-4">
                        {i18n.t("profilePage.noContentAvailable")}
                      </Typography>
                    </TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </Box>
        </Box>
      </>
    );
  }

  getCurrencySymbol(currency) {
    const currencySymbols = {
      eur: "€",
      usd: "$",
    };

    return currencySymbols[currency.toLowerCase()] || "";
  }

  handleImageChange(event) {
    const uploadedFile = event.target.files[0];
    this.setState({
      image: URL.createObjectURL(uploadedFile),
    });
  }

  handleRemoveImage() {
    this.setState({
      image: null,
    });

    const obj = {
      data: {
        image: null,
      },
    };

    _request.accounts.loading(async () => {
      return await _request.accounts.removeWaterMark(obj);
    }, this.onPostSend.bind(this));
  }

  handlePositionChange(event) {
    this.setState({ position: event.target.value });
  }

  handleSizeChange(event) {
    this.setState({ size: event.target.value });
  }

  handleOpacityChange(event) {
    this.setState({ opacity: event.target.value });
  }

  uploadDialog() {
    this.filesManager?.uploadDialog();
  }

  insertIconAction(title, Icon, cb) {
    return (
      <Button variant="contained" color="primary" onClick={cb}>
        <Icon />
        {i18n.t(title)}
      </Button>
    );
  }
  handleSubmit(event) {
    event.preventDefault();
  }

  saveWaterMark() {
    const { image, position, size, opacity } = this.state;

    const obj = {
      "watermark-image": image,
      "watermark-opacity": opacity,
      "watermark-size": size,
      "watermark-position": position,
    };

    _request.accounts.loading(async () => {
      return await _request.accounts.saveWaterMark(obj);
    }, this.onPostSend.bind(this));
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };
  watermarkContent() {
    const { image, position, size, opacity, selectedFile, isHovered } =
      this.state;

    const boxStyle = {
      padding: "10px",
      borderRadius: "10px",
      backgroundColor: isHovered ? "#f5f5f5" : "#42C0C7",
      boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      margin: "7px 35px 0px 0px",
      textAlign: "center",
      transition: "background-color 0.3s ease",
    };

    const inputStyle = {
      display: "none",
    };

    const fileNameStyle = {
      fontSize: "16px",
      fontWeight: "bold",
      borderRadius: "5px",
      color: "#165d76",
    };

    return (
      <Paper
        elevation={2}
        className="max-w-md p-4"
        sx={{ backgroundColor: "var(--background-menu)" }}>
        <Box className="flex justify-between gap4 mb-4 mt-4">
          <Typography
            variant="h5"
            component="h5"
            sx={{ color: "var(--text-color)" }}>
            {i18n.t("profilePage.watermarkSettings")}
          </Typography>
          <Button
            onClick={this.handleRemoveImage}
            variant="outlined"
            sx={{ color: "rgb(66, 192, 199)" }}
            className="mt-4">
            {i18n.t("profilePage.removeWatermark")}
          </Button>
        </Box>
        <Box className="mt-4 mb-4 border-0 border-t border-solid border-gray-300" />
        <Box className="flex justify-between mt-4 mb-4">
          <Box sx={{ width: "60%" }}>
            <Typography component="span" sx={{ color: "var(--text-color)" }}>
              {i18n.t("profilePage.watermarkImage")}
            </Typography>
            <Box
              style={boxStyle}
              onMouseEnter={this.handleMouseEnter}
              onMouseLeave={this.handleMouseLeave}>
              <label htmlFor="fileInput" style={{ cursor: "pointer" }}>
                <input
                  id="fileInput"
                  style={inputStyle}
                  type="file"
                  onChange={this.handleImageChange}
                />
                {selectedFile ? (
                  <div style={fileNameStyle}>{selectedFile.name}</div>
                ) : (
                  <div style={fileNameStyle}>
                    {i18n.t("profilePage.chooseImage")}
                  </div>
                )}
              </label>
            </Box>
          </Box>
          <Box sx={{ width: "40%" }}>
            <Typography component="span" sx={{ 
              color: "var(--text-color)",
              marginBottom: "8px",
              display: "block",
              fontSize: "14px",
              fontWeight: 500
            }}>
              {i18n.t("profilePage.position")}
            </Typography>
            <Select
              sx={{
                ...this.getSelectStyles(),
                width: "100%"
              }}
              MenuProps={this.getMenuProps()}
              labelId="position-label"
              variant="outlined"
              id="position-select"
              value={position}
              onChange={this.handlePositionChange}>
              <MenuItem value="top-left">
                {i18n.t("profilePage.topLeft")}
              </MenuItem>
              <MenuItem value="top-right">
                {i18n.t("profilePage.topRight")}
              </MenuItem>
              <MenuItem value="bottom-left">
                {i18n.t("profilePage.bottomLeft")}
              </MenuItem>
              <MenuItem value="bottom-right">
                {i18n.t("profilePage.bottomRight")}
              </MenuItem>
            </Select>
          </Box>
        </Box>
        <Box className="flex justify-between mt-4 mb-4 gap-4">
          <Box sx={{ width: "60%" }}>
            <Typography component="span" sx={{ 
              color: "var(--text-color)",
              marginBottom: "8px",
              display: "block",
              fontSize: "14px",
              fontWeight: 500
            }}>
              {i18n.t("profilePage.size")}
            </Typography>
            <TextField
              type="number"
              fullWidth
              value={size}
              onChange={this.handleSizeChange}
              sx={this.getTextFieldStyles()}
            />
          </Box>
          <Box sx={{ width: "40%" }}>
            <Typography component="span" sx={{ 
              color: "var(--text-color)",
              marginBottom: "8px",
              display: "block",
              fontSize: "14px",
              fontWeight: 500
            }}>
              {i18n.t("profilePage.opacity")}
            </Typography>
            <TextField
              type="number"
              fullWidth
              value={opacity}
              onChange={this.handleOpacityChange}
              sx={this.getTextFieldStyles()}
            />
          </Box>
        </Box>
        {image && (
          <Box
            sx={{
              width: "100%",
              marginTop: "20px",
              marginBottom: "20px",
              height: "250px",
            }}>
            <Typography component="span" sx={{ color: "var(--text-color)" }}>
              {i18n.t("profilePage.watermarkPreview")}
            </Typography>
            <WaterMark
              sx={{ width: "100%" }}
              imageUrl={image}
              watermarkUrl={image}
              watermarkOpacity={opacity}
              watermarkSize={size}
              watermarkPosition={position}
            />
          </Box>
        )}
        <Box className="flex justify-start">
          <Box onClick={this.saveWaterMark} className="btnDark mt-4">
            {i18n.t("save")}
          </Box>
        </Box>
      </Paper>
    );
  }

  renderTopPanel() {
    return (
      <Box className="flex between centerV bgDarkTheme pad10 h-[5.313rem]">
        <Box className="flex1 flex gap8 font f28 col black07">
          <Typography
            className="page-title"
            sx={{ padding: 5, color: "var(--text-color)" }}>
            {i18n.t("pages.profile")}
          </Typography>
        </Box>
      </Box>
    );
  }

  render() {
    const { value, metaData } = this.state;
    return (
      <Box className="flex1">
        {this.renderTopPanel()}
        <Box className="flex1" sx={{ padding: "25px 50px" }}>
          <Tabs
            value={value}
            sx={{ color: "var(--text-color)" }}
            onChange={this.handleChange}
            aria-label="basic tabs example">
            <Tab
              sx={{ color: "var(--text-color)" }}
              label={i18n.t("profilePage.account")}
              {...a11yProps(0)}
            />
            <Tab
              sx={{ color: "var(--text-color)" }}
              label={i18n.t("profilePage.password")}
              {...a11yProps(1)}
            />
            <Tab
              sx={{ color: "var(--text-color)" }}
              label={i18n.t("profilePage.subscriptionBilling")}
              {...a11yProps(2)}
            />
            <Tab
              sx={{ color: "var(--text-color)" }}
              label={i18n.t("profilePage.watermark")}
              {...a11yProps(3)}
            />
            {config.aiAssistants && (
              <Tab
                sx={{ color: "var(--text-color)" }}
                label={i18n.t("aiAssistants.tab")}
                {...a11yProps(4)}
              />
            )}
          </Tabs>
          <CustomTabPanel value={value} index={0}>
            {this.accountContent()}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={1}>
            {this.passwordContent()}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={2}>
            {this.subscriptionContent(metaData)}
          </CustomTabPanel>
          <CustomTabPanel value={value} index={3}>
            {this.watermarkContent()}
          </CustomTabPanel>
          {config.aiAssistants && (
            <CustomTabPanel value={value} index={4}>
              <AiAssistantsTab />
            </CustomTabPanel>
          )}
        </Box>
      </Box>
    );
  }
}
